<app-esqueleto-tableros>
  <div titulo class="encabezadosSeparacion">
    <span class="headerCintilla1">{{ "menu." + dataService.moduleSelect | translate }}</span>
    <span class="bullSeparation">&bull;</span>
    <span class="headerCintilla2">{{ "menu." + dataService.subModuleSelect | translate }}</span>
  </div>
  <!-- FILTROS -->
  <!-- Filtro de Períodos -->
  <app-filters filtros [name]="'filtros.per' | translate" [array]="Periodos" [typeFilter]="Filters.PERIOD" 
    [click]="true" (eventClick)="cambioPeriodo($event)">
  </app-filters>
  <!-- Filtro de Escenarios -->
  <app-filters filtros [name]="'proyFinanciera.escenarioProyeccion.escenario' | translate"
    [array]="escenariosShow" [typeFilter]="Filters.ESCENARIOS" [click]="false"
    (eventClick)="escenarioChange($event)">
  </app-filters>
  <!-- Filtro de Sucursales -->
  @if(sucursales.length > 1 ){
    <app-filters filtros [name]="'filtros.sucursales'+tagInstitucion | translate" [array]="sucursales"
      [typeFilter]="Filters.ESCENARIOS" [click]="false"
      (eventClick)="sucursalChange($event)">
    </app-filters> 
  }
  <app-filters filtros [name]="'filtros.segmentos' | translate"
    [array]="segmentos" [typeFilter]="Filters.ESCENARIOS" [click]="false"
    (eventClick)="filtroSegmento($event)">
  </app-filters>
  <div borrador>
    <div class="w3-button w3-dropdown-click" style="transform: scale(0.9);" [ngStyle]="{'color':'gray'}"
      matTooltip="{{'tooltips.borrar-filtros'|translate}}" (click)="resetFilters()">
      <img src="./../../../../assets/img/eraser.png">
    </div>
  </div>
   <!-- CONTENIDO -->
  <div contenido class="zonaContenido">
    <!-- Tabla de indicadores -->
    <div class="zona1 w3-row">
      <div class="w3-row w3-header-cuadrante">
        <div class="w3-half hijoizquierdaTitle w3-titulo-contenidomenu">
          <span class="w3-margin-left-contenido">
            @if(!consolidado){{{'segPresupuestal.analisisSegmento.sucursal'+tagInstitucion | translate}}} {{ sucursalSeleccionada?.name }}</span>
          <span class="w3-punto-subtitulo w3-margin-left-filter">&bull;</span>
          <span class=" w3-margin-left-filter w3-subtitulo">{{ periodoSeleccionado?.nombre}} | {{ escenarioSeleccionado?.name }}</span>
        </div>
        <div class="w3-rest w3-right">
          <mat-icon class="w3-button w3-margin-right-contenido" [ngStyle]="{'color':'gray', 'cursor': 'pointer'}"
              [matMenuTriggerFor]="opcionesTabla" matTooltip="Más opciones">
              more_vert
          </mat-icon>
          <mat-menu #opcionesTabla="matMenu">
            @if(segmentoEnc.movimientos){
              <button class="mat-menu-item w3-caja-menu" mat-menu-item [matMenuTriggerFor]="menuMetrica">
                <mat-icon [ngStyle]="{'color':'gray'}">tag</mat-icon>
                <span>{{'menu.Metrica' | translate}}</span>
              </button>  
            }            
            <button class="mat-menu-item" mat-menu-item (click)="exportarTabla()">
              <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">description</mat-icon>
              <span>{{'menu.Exportar'|translate}}</span>
            </button> 
          <mat-menu #menuMetrica="matMenu">
            <button class="mat-menu-item w3-caja-menu" mat-menu-item [ngClass]="{'w3-disabled':encMet === 1}" [disabled]="encMet === 1"  (click)="cambioConsolidadoSaldo(1)">
              <span>{{'segPresupuestal.estadoFinanciero.metrica1'|translate}}</span>
            </button>
            <button class="mat-menu-item w3-caja-menu" mat-menu-item [ngClass]="{'w3-disabled':encMet === 2}" [disabled]="encMet === 2" (click)="cambioConsolidadoSaldo(2)">
              <span>{{'segPresupuestal.estadoFinanciero.metrica2'|translate}}</span>
            </button>
          </mat-menu>
          </mat-menu>
        </div>
      </div>
      <div class="w3-row zonaTabla w3-scroll">
        @if(dataVisible.length === 0){
          <app-skeleton-table [columnas]="6" [filas]="6"/>
        }@else {
          <table class="w3-table">
            <thead>
              @if(encMet == 2){
                <tr class="w3-center">
                  <th colspan="2" class="stikyColumBlanco"></th>
                  <th colspan="4" class="w3-table-titleLow stikyColumCon w3-border-right-balance">{{'segPresupuestal.analisisSegmento.tituloTabla3' | translate}}</th>
                  <th colspan="4" class="w3-table-titleLow stikyColumCon">{{'segPresupuestal.analisisSegmento.tituloTabla2' | translate}}</th>  
                </tr>                
              }
              <tr class="w3-table-title w3-center" style="line-height: 1.2;">
                  <th class="w3-border-right-balance marginsH" style="width: 110px;"
                  [ngClass]="encMet == 2 ? 'stikyColumCon2' : 'stikyColumCon'">
                      {{'segPresupuestal.analisisSegmento.titTab1' | translate}}
                  </th>
                  <th class="w3-border-right-balance" style="min-width: 300px;"
                  [ngClass]="encMet == 2 ? 'stikyColumCon2' : 'stikyColumCon'">
                    <div class="tituloIcono">
                      <mat-icon class="iconoMen iconoIzq" (click)="contraerExpandirTodo()"
                        [matTooltip]="(!contraerExpandir
                          ? 'segPresupuestal.estadoFinanciero.expandirT'
                          : 'segPresupuestal.estadoFinanciero.contraerT') | translate">
                        {{ contraerExpandir ? 'expand_more' : 'chevron_right' }}
                      </mat-icon>
                      <span>{{ 'segPresupuestal.estadoFinanciero.titTab2' | translate }}</span>
                    </div>
                  </th>
                  <th class="w3-border-right-balance marginsH" style="min-width: 150px;"
                  [ngClass]="encMet == 2 ? 'stikyColumCon2' : 'stikyColumCon'">
                      {{'segPresupuestal.analisisSegmento.titTab3' | translate}}
                  </th>
                  <th class="w3-border-right-balance" style="min-width: 150px;"
                  [ngClass]="encMet == 2 ? 'stikyColumCon2' : 'stikyColumCon'">
                    <div class="tituloIcono">
                      <span>{{'segPresupuestal.analisisSegmento.titTab4' | translate}}</span>
                      <mat-icon class="iconoMen iconoDer" (click)="onSinSaldoChange()" matTooltip="Sin saldo">
                        {{ !sinSaldo ? 'filter_alt' : 'filter_alt_off' }}</mat-icon>
                    </div>
                  </th>
                  <th class="w3-border-right-balance marginsH" style="min-width: 150px;"
                  [ngClass]="encMet == 2 ? 'stikyColumCon2' : 'stikyColumCon'">
                      {{'segPresupuestal.analisisSegmento.titTab5' | translate}}
                  </th>
                  <th class="w3-border-right-balance" style="min-width: 180px;"
                  [ngClass]="encMet == 2 ? 'stikyColumCon2' : 'stikyColumCon'">
                    <div class="tituloIcono">
                      <span>{{'segPresupuestal.analisisSegmento.titTab6' | translate}}</span>
                      <mat-icon class="iconoMen iconoDer" (click)="semaforo = !semaforo" matTooltip="Semáforo">
                        {{ !semaforo ? 'traffic' : 'traffic' }}</mat-icon>
                    </div>
                  </th>
                  @if(encMet === 2){
                    <th class="w3-border-right-balance marginsH" style="min-width: 150px;"
                    [ngClass]="encMet == 2 ? 'stikyColumCon2' : 'stikyColumCon'">
                        {{'segPresupuestal.analisisSegmento.titTab3' | translate}}
                    </th>
                    <th class="w3-border-right-balance" style="min-width: 150px;"
                    [ngClass]="encMet == 2 ? 'stikyColumCon2' : 'stikyColumCon'">
                      <div class="tituloIcono">
                        <span>{{'segPresupuestal.analisisSegmento.titTab4' | translate}}</span>
                        <mat-icon class="iconoMen iconoDer" (click)="onSinSaldoChange()" matTooltip="Sin saldo">
                          {{ !sinSaldo ? 'filter_alt' : 'filter_alt_off' }}</mat-icon>
                      </div>
                    </th>
                    <th class="w3-border-right-balance marginsH" style="min-width: 150px;"
                    [ngClass]="encMet == 2 ? 'stikyColumCon2' : 'stikyColumCon'">
                        {{'segPresupuestal.analisisSegmento.titTab5' | translate}}
                    </th>
                    <th class="w3-border-right-balance" style="min-width: 180px;"
                    [ngClass]="encMet == 2 ? 'stikyColumCon2' : 'stikyColumCon'">
                      <div class="tituloIcono">
                        <span>{{'segPresupuestal.analisisSegmento.titTab6' | translate}}</span>
                        <mat-icon class="iconoMen iconoDer" (click)="semaforo = !semaforo" matTooltip="Semáforo">
                          {{ !semaforo ? 'traffic' : 'traffic' }}</mat-icon>
                      </div>
                    </th>
                  }
              </tr>
            </thead>
            <tbody>
              @for (seg of dataVisible; track seg.id; let i = $index) {
                @if(seg.segmentoId === segmentoEnc.id){
                  <tr class="w3-table-trtd" [style.cursor]="seg.hijos.length > 0 ? 'pointer' : 'default'"  style="line-height: 1.2;"
                    [ngClass]="{'selection' : segmentoSelect.id === seg.id}" (click)="selectSegmento(seg)">
                    <td class="borderLowDSI marginsH alinRight">{{ seg.codigo }}</td>
                    <td class="borderAllLow alinLeft" [style.padding-left]="getIndentacion(seg)">
                      @if (seg.hijos.length > 0) {
                        <mat-icon class="material-icons-outlined" (click)="toggleExpansion(seg)" style="vertical-align: middle; font-size: 18px;"
                          [matTooltip]="(!seg.expandido 
                            ? 'segPresupuestal.estadoFinanciero.expandir' 
                            : 'segPresupuestal.estadoFinanciero.contraer') | translate">
                            {{ !seg.expandido ? 'expand_more' : 'chevron_right' }}
                        </mat-icon>
                      }
                      <span [style.font-weight]="seg.nivel === 1 ? 'bold' : 'normal'"
                      [style.margin-left]="seg.hijos == 0 ? '7px' : '0px'">{{ seg.nombre }}</span>
                    </td>
                    @if(encMet === 2){
                      <td class="borderAllLow marginsH alinRight">
                        {{ seg.presupuestoMov !== '-' ? (seg.presupuestoMov | formaterNumber:2:miles:decimal) : '-' }}</td>
                      <td class="borderAllLow marginsH alinRight">{{ seg.realMov !== '-' ? (seg.realMov | formaterNumber:2:miles:decimal) : '-' }}</td>
                      <td class="borderAllLow marginsH alinRight">
                        <span [style.color]="semaforo ? obtenerColorSemaforo(seg.cumplimientoMov) : '#666'">
                          {{seg.variacion !== '-' ? (seg.variacion | formaterNumber:2:miles:decimal) : '-'}}
                        </span>
                      </td>
                      <td class="borderAllLow marginsH w3-center">
                        <span [style.color]="semaforo ? obtenerColorSemaforo(seg.cumplimientoMov) : '#666'">
                          {{seg.cumplimientoMov !== '-' ? (seg.cumplimientoMov | formaterNumber:2:miles:decimal) : '-'}} %
                        </span>
                      </td>  
                    }
                    <td class="borderAllLow marginsH alinRight">{{ seg.presupuesto !== '-' ? (seg.presupuesto | formaterNumber:2:miles:decimal) : '-' }}</td>
                    <td class="borderAllLow marginsH alinRight">{{ seg.real !== '-' ? (seg.real | formaterNumber:2:miles:decimal) : '-' }}</td>
                    <td class="borderAllLow marginsH alinRight">
                      <span [style.color]="semaforo ? obtenerColorSemaforo(seg.cumplimiento) : '#666'">
                        {{seg.variacion !== '-' ? (seg.variacion | formaterNumber:2:miles:decimal) : '-' }}
                      </span>
                    </td>
                    <td class="borderLowISI marginsH w3-center">
                      <span [style.color]="semaforo ? obtenerColorSemaforo(seg.cumplimiento) : '#666'">
                        {{ seg.cumplimiento !== '-' ? (seg.cumplimiento | formaterNumber:2:miles:decimal) : '-'}} %
                      </span>
                    </td>
                  </tr>  
                }
                
              }
            </tbody>
        </table>
        }
      </div>
    </div>
    <!-- Grafica segmento seleccionado -->
    <div class="zona2 w3-row">
      <div class="w3-row w3-header-cuadrante">
          <div class="w3-half hijoizquierdaTitle w3-titulo-contenidomenu">
            <span class="w3-margin-left-contenido">{{'segPresupuestal.razonesFinancieras.evolucion' | translate}} {{ segmentoSelect?.nombre }}</span>
            <span class="w3-punto-subtitulo w3-margin-left-filter">&bull;</span>
            <span class=" w3-margin-left-filter w3-subtitulo">{{ periodoSeleccionado?.nombre}} | {{ escenarioSeleccionado?.name }}</span>
          </div>
          <div class="w3-rest w3-right">
            <mat-icon class="w3-button iconoMen" [ngStyle]="{'color':'gray'}" fontSet="material-icons-outlined" 
              (click)="etiqueta = !etiqueta" [matTooltip]="etiqueta ? ('graf.desactivar'|translate) : ('graf.activar' | translate)">
              {{ etiqueta ? 'label_off' : 'label'}}
            </mat-icon>
            <mat-icon class="w3-button w3-dropdown-click iconoMen" [ngStyle]="{'color':'gray'}"
                (click)="ampliarGraf(0)" matTooltip="{{'tooltips.tooltipIcono2'|translate}}">
                zoom_out_map
            </mat-icon>
            <mat-icon class="w3-button w3-margin-right-contenido" [ngStyle]="{'color':'gray', 'cursor': 'pointer'}"
                [matMenuTriggerFor]="opcionesGraf" matTooltip="Más opciones">
                more_vert
            </mat-icon>
            <mat-menu #opcionesGraf="matMenu">
              <button class="mat-menu-item" mat-menu-item [matMenuTriggerFor]="menuGraf">
                <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">insert_chart</mat-icon>
                <span>{{'graf.graficas' | translate}}</span>
              </button> 
              <button class="mat-menu-item" mat-menu-item (click)="exportarGrafica(0)">
                <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">image</mat-icon>
                <span>{{'menu.Exportar'|translate}}</span>
              </button> 
            </mat-menu>
            <mat-menu #menuGraf>
              <button class="mat-menu-item" mat-menu-item 
                [ngClass]="{'w3-disabled': tipoGraf === typeGraph.COMBO2}"
                [disabled]="tipoGraf === typeGraph.COMBO2"
                (click)="cambiarTipoGrafica(typeGraph.COMBO2)">
                <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">bar_chart</mat-icon>
                <span>{{'graf.combinada'|translate}}</span>
              </button>
              <button class="mat-menu-item" mat-menu-item 
                [ngClass]="{'w3-disabled': tipoGraf === typeGraph.BAR}"
                [disabled]="tipoGraf === typeGraph.BAR"
                (click)="cambiarTipoGrafica(typeGraph.BAR)">
                <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">bar_chart</mat-icon>
                <span>{{'graf.barras'|translate}}</span>
              </button>              
              <button class="mat-menu-item" mat-menu-item 
                  [ngClass]="{'w3-disabled': tipoGraf === typeGraph.LINE}"
                  [disabled]="tipoGraf === typeGraph.LINE"
                  (click)="cambiarTipoGrafica(typeGraph.LINE)">
                  <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">show_chart</mat-icon>
                  <span>{{'graf.lineal'|translate}}</span>
              </button>
              <button class="mat-menu-item" mat-menu-item 
                  [ngClass]="{'w3-disabled': tipoGraf === typeGraph.AREA}"
                  [disabled]="tipoGraf === typeGraph.AREA"
                  (click)="cambiarTipoGrafica(typeGraph.AREA)">
                  <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">area_chart</mat-icon>
                  <span>{{'graf.area'|translate}}</span>
              </button>
            </mat-menu>
          </div>
        </div>
        <div class="w3-row zonaGrafPrin">
          @if(dataGraf.length > 0){
            <app-graficador 
              [data]="dataGraf"
              [labels]="etiquetasGraf"
              [type]="tipoGraf"
              [colors]="coloresGrafico"
              [axisY]="axisY"
              [axisX]="axisX"
              [zona]="0"
              [legend]="{enabled: true, position: 'bottom'}"
              [etiquetas]="etiqueta"
              [animations]="true"
              [setTwoLast]="ejes">
            </app-graficador>
          }@else {<app-skeleton-grafica />}
        </div>

    </div>
  </div>
</app-esqueleto-tableros>
<!--Modal ampliar grafica-->
<app-modal [isOpen]="modalOpen" (close)="modalOpen = !modalOpen">
  <div modal-header>
    <div class="w3-row w3-white" style="width: 70vw;">
      <!--Titulo grafica modal-->
      <div class="w3-row w3-half w3-white">
        <div class="w3-row w3-header-cuadrante padreizquierda" style="height: 6vh; margin-top: 10px; margin-left: 20px">
          <div class="w3-noventa2 w3-titulo-contenidomenu  hijoizquierdaTitle">
            <span class="w3-margin-left-contenido">{{'segPresupuestal.razonesFinancieras.evolucion' | translate}} {{ segmentoSelect?.nombre }}</span>
            <span class="w3-punto-subtitulo w3-margin-left-filter">&bull;</span>
            <span class=" w3-margin-left-filter w3-subtitulo">{{ periodoSeleccionado?.nombre}} | {{ escenarioSeleccionado?.name }}</span>
          </div>
        </div>
      </div>
      <!--cerrar modal-->
      <div class="w3-rest w3-right w3-white" style="height: 6vh;">
        <div class="w3-row" style="height: 3vh; transform: translate(0, 40%);">
          <!-- Icono de etiquetas para modal -->
          <mat-icon class="w3-button iconoMen" [ngStyle]="{'color':'gray'}" fontSet="material-icons-outlined" 
            (click)="etiqueta = !etiqueta" [matTooltip]="etiqueta ? ('graf.desactivar'|translate) : ('graf.activar' | translate)">
            {{ etiqueta ? 'label_off' : 'label'}}
          </mat-icon>
          <!-- Icono exportar -->
          <mat-icon class="w3-margin-right-contenido w3-button" [ngStyle]="{'color':'gray'}"
            (click)="exportarGrafica(0)" matTooltip="{{'menu.Exportar'|translate}}">
            image
          </mat-icon>
        </div>
      </div>
    </div>
  </div>
  <div modal-body>
    <!--area grafica-->
    <div style="width: 70vw;" >
      <div class="w3-row contentGraf">
        @if (modalOpen) {   
            <app-graficador 
              [data]="dataGraf" 
              [labels]="etiquetasGraf" 
              [type]="tipoGraf"
              [colors]="coloresGrafico" 
              [axisY]="axisY" 
              [axisX]="axisX" 
              [zona]="2" 
              [etiquetas]="etiqueta"
              [legend]="{enabled: true, position: 'bottom'}"
              [animations]="true"
              [setTwoLast]="ejes">
            </app-graficador>          
        }
      </div>
    </div>
  </div>
</app-modal>
